const styles = theme => ({
  root: {
    fontFamily: 'Univia Pro'
  }
});

export default styles;

